const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-kpis-drilling/shared/services/KpisDrillingRegistry");